export const AFFIRMATION_THEMES = [
  {
    id: 'bienetre',
    label: 'Bien-être',
    icon: 'Heart',
    color: '#f59e0b',
    images: [
      '/affirmations/bienetre1.jpg',
      'https://images.unsplash.com/photo-1761172889709-5431a9d59078?w=800&q=75',
      'https://images.unsplash.com/photo-1770035020222-4f096b48d215?w=800&q=75',
      'https://images.unsplash.com/photo-1760966433269-45363ef1e7fe?w=800&q=75',
      'https://images.unsplash.com/photo-1767358270353-f4863614f206?w=800&q=75'
    ],
    affirmations: [
      "Je mérite de me sentir bien chaque jour.",
      "Mon corps et mon esprit sont en harmonie.",
      "Je choisis la paix intérieure à chaque instant.",
      "Chaque respiration me remplit de sérénité.",
      "Je suis reconnaissant(e) pour ce moment présent.",
      "Le calme habite mon cœur et guide mes pensées.",
      "Je m'accorde le droit au repos et à la douceur.",
      "Mon bien-être est ma priorité et je l'honore.",
      "Je suis en paix avec qui je suis.",
      "Chaque jour est une nouvelle chance de me sentir bien.",
      "J'accueille la joie dans ma vie avec gratitude.",
      "Je libère toute tension et j'embrasse la légèreté.",
      "Mon esprit est clair, mon cœur est léger.",
      "Je suis exactement là où je dois être.",
      "La tranquillité m'enveloppe comme une douce lumière.",
      "Je choisis de nourrir mon âme avec de la bonté.",
      "Chaque cellule de mon corps vibre de bien-être.",
      "Je me permets de savourer les petits bonheurs.",
      "Le bonheur est un choix que je fais chaque matin.",
      "Je suis une source de paix pour moi et pour les autres.",
      "Mon énergie est positive et contagieuse.",
      "Je mérite l'amour, la joie et l'abondance.",
      "Je vis pleinement l'instant présent.",
      "Ma vie est remplie de moments précieux.",
      "Je rayonne de sérénité et de bienveillance.",
      "Chaque jour, je deviens une meilleure version de moi-même.",
      "Le sourire est mon allié au quotidien.",
      "Je suis en harmonie avec l'univers.",
      "Mon cœur déborde de gratitude.",
      "Je transforme chaque défi en opportunité de grandir.",
      "La paix intérieure est mon super-pouvoir.",
      "Je m'aime tel(le) que je suis, ici et maintenant.",
      "Mon âme est nourrie par la beauté du monde.",
      "Je choisis d'être heureux(se) aujourd'hui."
    ]
  },
  {
    id: 'confiance',
    label: 'Confiance en soi',
    icon: 'Shield',
    color: '#3b82f6',
    images: [
      'https://images.unsplash.com/photo-1720671656128-125a123f4dfa?w=800&q=75',
      'https://images.unsplash.com/photo-1634827056186-3b2d72c32709?w=800&q=75',
      'https://images.unsplash.com/photo-1633986636588-7da3d6595a12?w=800&q=75',
      'https://images.unsplash.com/photo-1605016834496-49a22923616b?w=800&q=75',
      'https://images.unsplash.com/photo-1670458179963-6f73fd8e9c61?w=800&q=75'
    ],
    affirmations: [
      "J'ai confiance en mes capacités.",
      "Je suis digne de succès et de réussite.",
      "Ma voix compte et mes idées ont de la valeur.",
      "Je me fais confiance pour prendre les bonnes décisions.",
      "Je suis capable d'accomplir tout ce que j'entreprends.",
      "Je crois en moi, même quand personne d'autre ne le fait.",
      "Mon potentiel est illimité.",
      "Je suis assez. Je fais assez. J'ai assez.",
      "Chaque erreur est une leçon qui me rend plus fort(e).",
      "Je n'ai pas besoin de l'approbation des autres pour avancer.",
      "Je suis le héros de ma propre histoire.",
      "Ma confiance grandit chaque jour un peu plus.",
      "Je mérite ma place dans ce monde.",
      "Je transforme mes doutes en détermination.",
      "Mon courage est plus grand que mes peurs.",
      "Je suis unique et c'est ma plus grande force.",
      "Je m'exprime avec assurance et authenticité.",
      "Chaque défi que je surmonte renforce ma confiance.",
      "Je suis fier(e) du chemin que j'ai parcouru.",
      "Je refuse de me comparer aux autres. Mon parcours est unique.",
      "Je suis la personne la mieux placée pour vivre ma vie.",
      "Ma valeur ne dépend pas du regard des autres.",
      "Je marche avec assurance vers mes rêves.",
      "Je suis un leader naturel dans ma propre vie.",
      "Mes imperfections font partie de ma beauté.",
      "Je mérite le respect, à commencer par le mien.",
      "Je suis capable de surmonter tous les obstacles.",
      "Chaque jour, je choisis de croire en moi.",
      "Je suis ma propre source d'inspiration.",
      "L'échec ne me définit pas, il me prépare.",
      "Je porte en moi la force de mille batailles gagnées.",
      "Ma confiance est inébranlable.",
      "Je suis né(e) pour accomplir de grandes choses.",
      "Je rayonne d'assurance et de charisme."
    ]
  },
  {
    id: 'sport',
    label: 'Sport',
    icon: 'Flame',
    color: '#ef4444',
    images: [
      '/affirmations/sport1.jpg',
      '/affirmations/sport2.jpg',
      'https://images.unsplash.com/photo-1759476598374-040d2ccf8184?w=800&q=75',
      'https://images.unsplash.com/photo-1774793152403-0b5d05389163?w=800&q=75',
      'https://images.unsplash.com/photo-1758684050596-15a238d24202?w=800&q=75'
    ],
    affirmations: [
      "Mon corps est une machine puissante et je la respecte.",
      "Chaque entraînement me rapproche de mes objectifs.",
      "La douleur d'aujourd'hui est la force de demain.",
      "Je suis plus fort(e) que je ne le pense.",
      "Mon corps peut accomplir des choses extraordinaires.",
      "Je repousse mes limites un peu plus chaque jour.",
      "La discipline est le pont entre mes objectifs et mes résultats.",
      "Je ne m'arrête pas quand je suis fatigué(e), je m'arrête quand j'ai terminé.",
      "Chaque goutte de sueur est un pas vers la victoire.",
      "Mon mental est plus fort que mon corps.",
      "Je suis un(e) athlète dans l'âme.",
      "La persévérance est ma plus grande qualité sportive.",
      "Mon corps me remercie à chaque effort que je lui donne.",
      "Je suis en compétition uniquement avec la personne que j'étais hier.",
      "Chaque kilomètre parcouru est une victoire.",
      "Mon énergie est inépuisable quand je suis déterminé(e).",
      "Je transforme la fatigue en motivation.",
      "Mon corps est mon temple et je le sculpte avec fierté.",
      "Rien ne peut m'empêcher d'atteindre mes objectifs fitness.",
      "Le sport est ma thérapie, mon exutoire, ma liberté.",
      "Je suis reconnaissant(e) pour ce que mon corps peut faire.",
      "Chaque répétition compte. Chaque seconde compte.",
      "Je suis bâti(e) pour l'endurance et la résilience.",
      "Mon esprit de compétition me pousse vers l'excellence.",
      "Je suis fier(e) de chaque progrès, aussi petit soit-il.",
      "La régularité est la clé de ma transformation.",
      "Mon corps se renforce à chaque séance.",
      "Je choisis la santé, la force et la vitalité.",
      "Chaque jour est un nouveau record personnel en devenir.",
      "Je suis un guerrier, une guerrière. Je ne lâche rien.",
      "Le mouvement est un cadeau que je m'offre chaque jour.",
      "Ma détermination sportive inspire ceux qui m'entourent.",
      "Je célèbre chaque victoire, chaque effort, chaque sueur.",
      "Mon potentiel physique n'a pas de limite."
    ]
  },
  {
    id: 'determination',
    label: 'Détermination',
    icon: 'Target',
    color: '#8b5cf6',
    images: [
      'https://images.unsplash.com/photo-1593624972037-b33e556cbc7c?w=800&q=75',
      'https://images.unsplash.com/photo-1750950311852-60bf00db31f7?w=800&q=75',
      'https://images.unsplash.com/photo-1669937736289-031161d1d9e7?w=800&q=75',
      'https://images.unsplash.com/photo-1650747818065-9e26c66a1ed0?w=800&q=75',
      'https://images.unsplash.com/photo-1768059976295-262325a762d6?w=800&q=75'
    ],
    affirmations: [
      "Je ne recule devant rien.",
      "Ma volonté est plus forte que n'importe quel obstacle.",
      "Chaque jour, je me rapproche de mes rêves.",
      "L'échec n'est qu'un détour, jamais une impasse.",
      "Je suis implacable dans la poursuite de mes objectifs.",
      "Les difficultés ne me brisent pas, elles me forgent.",
      "Je suis le(la) seul(e) maître de ma destinée.",
      "Ma détermination est mon arme secrète.",
      "Quand le monde dit 'abandonne', ma voix intérieure dit 'encore une fois'.",
      "Je construis mon avenir avec chaque action d'aujourd'hui.",
      "Rien ne se met en travers de mon chemin sans ma permission.",
      "Je suis tenace, persévérant(e) et inarrêtable.",
      "Chaque 'non' me rapproche d'un 'oui'.",
      "Je choisis d'avancer même quand la route est difficile.",
      "Ma passion alimente ma persévérance.",
      "Les obstacles sont les marches vers mon succès.",
      "Je ne suis pas une option, je suis une priorité.",
      "Mon ambition n'a pas de plafond.",
      "Je me relève à chaque chute, plus fort(e) qu'avant.",
      "Le succès n'est pas final, l'échec n'est pas fatal.",
      "Je suis architecte de mon propre destin.",
      "Ma discipline quotidienne crée des résultats extraordinaires.",
      "Je refuse la médiocrité. Je vise l'excellence.",
      "Chaque petite action est une graine de succès.",
      "Je suis le feu qui ne s'éteint jamais.",
      "Ma vision est claire et ma détermination absolue.",
      "Je transforme l'impossible en possible.",
      "Le doute n'a pas sa place dans mon esprit.",
      "Je suis programmé(e) pour réussir.",
      "Quand tout semble perdu, je trouve un chemin.",
      "Ma force de caractère est indestructible.",
      "Je fais ce qui doit être fait, même quand c'est difficile.",
      "Le monde appartient à ceux qui osent.",
      "Je suis la tempête et le calme après la tempête."
    ]
  },
  {
    id: 'beaute',
    label: 'Se sentir beau',
    icon: 'Sparkles',
    color: '#ec4899',
    images: [
      'https://images.unsplash.com/photo-1618249214928-a54dfef1b6f6?w=800&q=75',
      'https://images.unsplash.com/photo-1615386207355-16d082b8ad77?w=800&q=75',
      'https://images.unsplash.com/photo-1762101640373-753c491eb15c?w=800&q=75',
      'https://images.unsplash.com/photo-1642350361533-d8252bd831fb?w=800&q=75',
      'https://images.unsplash.com/photo-1672243168215-7931d1e19ade?w=800&q=75'
    ],
    affirmations: [
      "Je suis beau/belle, exactement comme je suis.",
      "Ma beauté vient de l'intérieur et rayonne à l'extérieur.",
      "Mon sourire illumine le monde autour de moi.",
      "Je suis unique et c'est ce qui me rend magnifique.",
      "Mon corps est un chef-d'œuvre en perpétuelle évolution.",
      "Je m'aime sans condition et sans réserve.",
      "Chaque imperfection est une marque de caractère.",
      "Je rayonne de beauté naturelle.",
      "Mon regard est profond et captivant.",
      "Je suis à l'aise dans ma peau et fier(e) de mon reflet.",
      "La beauté que je porte en moi est intemporelle.",
      "Mon énergie positive me rend irrésistible.",
      "Je suis un diamant brut qui brille de mille feux.",
      "Mon charme est dans ma personnalité autant que dans mon apparence.",
      "Je célèbre mon corps pour tout ce qu'il me permet de vivre.",
      "Mon style est unique et reflète qui je suis vraiment.",
      "Je suis la plus belle version de moi-même.",
      "Mon aura attire les bonnes personnes et les bonnes énergies.",
      "Je mérite de me sentir beau/belle chaque jour.",
      "Ma confiance me rend encore plus attirant(e).",
      "Je ne me compare à personne. Ma beauté est incomparable.",
      "Mon corps raconte mon histoire et elle est magnifique.",
      "Je suis lumière, je suis grâce, je suis beauté.",
      "Chaque ride est une trace de sagesse et de vécu.",
      "Mon cœur est beau, et ça se voit.",
      "Je dégage une énergie solaire et magnétique.",
      "Mon apparence est le reflet de mon amour-propre.",
      "Je suis sculpté(e) par la vie et ça me rend unique.",
      "Mon visage reflète la beauté de mon âme.",
      "Je choisis de voir ma beauté avant mes défauts.",
      "Je suis une œuvre d'art vivante.",
      "Mon authenticité est ma plus belle parure.",
      "Je brille par ma simplicité et ma sincérité.",
      "Mon existence même est un acte de beauté."
    ]
  },
  {
    id: 'guerir',
    label: 'Guérir',
    icon: 'Leaf',
    color: '#10b981',
    images: [
      'https://images.unsplash.com/photo-1698183119745-594aad5cf571?w=800&q=75',
      'https://images.unsplash.com/photo-1436306896198-6f280fe8481b?w=800&q=75',
      'https://images.unsplash.com/photo-1682437561884-47780278184b?w=800&q=75',
      'https://images.unsplash.com/photo-1596237434075-1022eeed348c?w=800&q=75',
      'https://images.unsplash.com/photo-1433048980017-63f162f662b0?w=800&q=75'
    ],
    affirmations: [
      "Mon corps possède une capacité de guérison extraordinaire.",
      "Chaque jour, je guéris un peu plus.",
      "Je libère ce qui ne me sert plus pour faire place à la guérison.",
      "Mon esprit est un allié puissant dans ma guérison.",
      "Je mérite de guérir et de retrouver ma pleine santé.",
      "Chaque cellule de mon corps travaille à ma guérison.",
      "La lumière de l'espoir brille en moi, même dans l'obscurité.",
      "Je pardonne à mon corps et je l'accompagne vers la guérison.",
      "Mon processus de guérison est parfait, même s'il est lent.",
      "Je choisis de croire en ma capacité de me régénérer.",
      "La douleur est temporaire, la guérison est permanente.",
      "Je nourris mon corps avec amour pour accélérer ma guérison.",
      "Mon cœur guérit à chaque battement.",
      "Je suis patient(e) avec moi-même pendant ma guérison.",
      "Chaque nuit de sommeil est une séance de guérison.",
      "Mon corps sait comment se réparer. Je lui fais confiance.",
      "Je visualise ma santé parfaite et elle se manifeste.",
      "La guérison coule en moi comme une rivière de lumière.",
      "Je me libère de la peur et j'accueille la guérison.",
      "Mon passé ne définit pas ma santé future.",
      "Je suis plus fort(e) que ma maladie.",
      "Chaque pas vers la guérison est une victoire.",
      "Mon système immunitaire est puissant et vigilant.",
      "Je mérite une vie sans douleur et sans souffrance.",
      "Mon corps est mon allié, pas mon ennemi.",
      "La guérison commence dans mon esprit.",
      "Je suis entouré(e) d'amour et cela m'aide à guérir.",
      "Chaque inspiration apporte de l'énergie de guérison.",
      "Je fais confiance au timing de ma guérison.",
      "Mon âme se répare en même temps que mon corps.",
      "La nature m'offre ses pouvoirs de guérison et je les accepte.",
      "Je suis en route vers une santé rayonnante.",
      "Chaque larme versée est une blessure qui se referme.",
      "Je me reconstruis, plus fort(e) et plus sage."
    ]
  }
];
